import { useContext } from "react";
import { SubscriptionsContext } from "../../../store/SubscriptionsContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen, faPlus } from "@fortawesome/free-solid-svg-icons";
import { ApplicationPeriod } from "../../../../../api/season";
//TODO should not depend on season
type TierListProps = {
  onEditSubscription: (subscriptionId: string) => void;
  onCreateTier: (subscriptionId: string) => void;
  onEditTier: (tierId: string) => void;
  areWeInSeason: boolean;
  applicationPeriod: ApplicationPeriod;
  onEditAndCreateWarning: () => void;
};
const TierList = ({
  onCreateTier,
  onEditSubscription,
  onEditTier,
  areWeInSeason,
  applicationPeriod,
  onEditAndCreateWarning,
}: TierListProps) => {
  const { subscriptions } = useContext(SubscriptionsContext);

  const subscriptionList = subscriptions.map((sub) => {
    const tierList = sub.tiers.map((tier) => {
      return (
        <li
          key={tier.id}
          className={
            areWeInSeason ||
            applicationPeriod !== ApplicationPeriod.ApplicationClosed
              ? "info-card tier-info-card"
              : "info-card tier-info-card info-card-clickable"
          }
          onClick={() => {
            areWeInSeason ||
            applicationPeriod !== ApplicationPeriod.ApplicationClosed
              ? onEditAndCreateWarning()
              : handleEditTier(tier.id);
          }}
        >
          <h4 className="header-no-margin-bottom">{tier.name}</h4>
          <div className="tier-flexbox">
            <div>
              <p>Price: {tier.price} kr</p>
              <p>Returning Member Price: {tier.oldCsaMemberPrice} kr</p>
              {tier.dependsOn && <p>Initial spots: {tier.spots}</p>}
            </div>
          </div>
        </li>
      );
    });

    return (
      <li key={sub.id} className="wrapper-card pink">
        <div className="subscription-header">
          <h3 className="sub-h3">
            {sub.name}{" "}
            {sub.isCombo === false && (
              <span className="slim-header">
                {sub.spotsTaken}/{sub.spots}
              </span>
            )}
          </h3>
          {!areWeInSeason &&
            applicationPeriod === ApplicationPeriod.ApplicationClosed && (
              <div className="sub-page-dubble-btn">
                <button
                  className={"btn"}
                  title="Add Tier"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCreateTier(sub.id);
                  }}
                >
                  <FontAwesomeIcon icon={faPlus} style={{ color: "#ffffff" }} />
                </button>

                <button
                  className="btn"
                  title="Edit"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleEditSubscription(sub.id);
                  }}
                >
                  <FontAwesomeIcon icon={faPen} style={{ color: "#ffffff" }} />
                </button>
              </div>
            )}
        </div>
        <ul>{tierList}</ul>
      </li>
    );
  });

  function handleEditSubscription(id: string) {
    onEditSubscription(id);
  }
  function handleCreateTier(id: string) {
    onCreateTier(id);
  }
  function handleEditTier(id: string) {
    if (
      !areWeInSeason &&
      applicationPeriod === ApplicationPeriod.ApplicationClosed
    ) {
      onEditTier(id);
    }
  }
  return subscriptionList.length < 1 ? (
    <div className="info-card">
      <p>
        You currently have no subscriptions. Create one by clicking the button
        in the top right corner.
      </p>
    </div>
  ) : (
    <ul>{subscriptionList}</ul>
  );
};
export default TierList;
